import React, { Fragment } from 'react'
import RecordHeading from '../../../ui/record-heading'
import RecordDisplay from '../../../ui/record-display'

const PersonnelDetailsView = ({ record, children }) => (
  <Fragment>
    <RecordHeading record={record} />

    <RecordDisplay
      record={record.personnel_details}
      showRaw
      recordBase="details"
      level1={[
        {
          key: 'dob',
          label: 'Date of Birth',
        },
        {
          key: 'email',
          label: 'Email Address',
        },
      ]}
      level2={[
        {
          key: 'start_date',
          label: 'Start date',
        },
        {
          key: 'role',
          label: 'Role',
        },
        {
          key: 'relationship',
          label: 'Relationship',
        },
        {
          key: 'position_type',
          label: 'Position type',
        },
        {
          key: 'authorised',
          label: 'Authorised',
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
        },
        {
          key: 'carer_crn',
          label: 'CRN',
        },
        {
          key: 'qualifications.0.type',
          label: 'Main qualification',
        },
        {
          key: 'qualifications.1.type',
          label: 'Secondary qualification',
        },
        {
          key: 'address.line_1',
          label: 'Address Line 1',
        },
        {
          key: 'address.line_2',
          label: 'Address Line 2',
        },
        {
          key: 'address.suburb',
          label: 'Suburb',
        },
        {
          key: 'address.postcode',
          label: 'Postcode',
        },
      ]}
    />

    {children}
  </Fragment>
)

export default PersonnelDetailsView



// WEBPACK FOOTER //
// ./src/personnel/details/views/index.jsx